/* ============================================================
   KAMUS TERJEMAHAN

   Letakkan di: app/i18n/dictionary.js

   ⚠️⚠️ SELURUH TEKS INGGRIS DI BERKAS INI ADALAH DRAF SAYA, BUKAN
   TERJEMAHAN RESMI. Wajib diperiksa orang sebelum tayang.

   Yang paling perlu diperiksa adalah nama layanan medis. Beberapa
   contoh keputusan yang saya ambil dan bisa saja keliru menurut istilah
   yang dipakai RS:

     "IGD"                -> "Emergency Department (ER)"
        Sebagian RS di Indonesia memakai "Emergency Unit". Samakan
        dengan papan penunjuk fisik di rumah sakit, bukan dengan
        terjemahan harfiah.
     "Terapi Wasir"       -> "Hemorrhoid Treatment"
     "Endoskopi Urologi"  -> "Urological Endoscopy"
     "Klinik Nyeri"       -> "Pain Clinic"
     "Laboratorium Lengkap" -> "Complete Laboratory"
        "Lengkap" di sini maksudnya apa - jenis pemeriksaannya banyak,
        atau buka 24 jam? Terjemahannya berbeda tergantung jawabannya.
     "Pelayanan"          -> "Patient Services"
        Ini yang paling saya ragukan. "Pelayanan" berdiri sendiri
        sebagai nama menu tidak jelas maksudnya bahkan dalam Bahasa
        Indonesia. Tanyakan ke tim RS menu ini isinya apa, lalu beri
        nama yang lebih tegas di KEDUA bahasa.

   ============================================================
   ATURAN MENAMBAH KUNCI

   1. Struktur id dan en HARUS sama persis. Kunci yang ada di id tapi
      tidak ada di en akan jatuh ke teks Indonesia (lihat fungsi t()
      di LanguageProvider) - tidak error, tapi diam-diam salah bahasa.
   2. Kunci ditulis dari yang umum ke yang khusus:
      header.menu.layanan.label, bukan labelMenuLayananHeader.
   3. JANGAN merakit kalimat dari potongan. Tulis kalimat utuh per
      kunci. Urutan kata tiap bahasa berbeda, dan kalimat yang dirakit
      dari dua kunci akan kacau di salah satunya.
   ============================================================ */

export const DICTIONARY = {
  id: {
    header: {
      utility: {
        contact: "Hubungi Kami",
        welcome: "Selamat datang di RS JMC",
        welcomeShort: "Selamat datang",
        brand: "RS JMC",
      },
      cta: {
        contact: "Kontak",
        appointment: "Buat Janji Temu",
      },
      nav: {
        home: "Beranda",
        schedule: "Jadwal Dokter",
        career: "JMC Karir",
      },
      menu: {
        layanan: {
          label: "Fasilitas & Layanan",
          cta: "Lihat semua layanan",
          promo: {
            title: "Fasilitas penunjang",
            p1: "Operating Theatre",
            p2: "CT-Scan",
            p3: "NICU-PICU",
            p4: "ICU-ICCU",
          },
        },
        tentang: {
          label: "Tentang Kami",
          cta: "Selengkapnya tentang kami",
          promo: {
            title: "Nyaman seperti di rumah",
            p1: "Taman bermain anak",
            p2: "Kantin sehat",
            p3: "Area tunggu keluarga",
          },
        },
      },
      layanan: {
        dokterUmum: "Dokter Umum",
        dokterSpesialis: "Dokter Spesialis",
        dokterGigi: "Dokter Gigi",
        mcu: "Medical Check Up",
        igd: "IGD",
        laboratorium: "Laboratorium Lengkap",
        apotek: "Apotek",
        deliveryObat: "Delivery Obat",
        swabPcr: "Swab & PCR Test",
        babySpa: "Baby Spa",
        telemedicine: "Telemedicine",
        rawatInap: "Rawat Inap",
        klinikNyeri: "Klinik Nyeri",
        terapiWasir: "Terapi Wasir",
        endoskopiUrologi: "Endoskopi Urologi",
        skincare: "JMC Skincare",
        asuransi: "Asuransi",
        pelayanan: "Pelayanan",
      },
      tentang: {
        about: "About",
        aboutDesc: "Profil dan sejarah RS JMC",
        businessUnit: "Business Unit",
        businessUnitDesc: "Unit usaha dan layanan terkait",
        gallery: "Gallery",
        galleryDesc: "Dokumentasi kegiatan dan fasilitas",
        edukasi: "Edukasi Kesehatan",
        edukasiDesc: "Artikel dan tips dari dokter kami",
      },
      a11y: {
        openMenu: "Buka menu",
        closeMenu: "Tutup menu",
        chooseLanguage: "Pilih bahasa",
      },
    },

    /* ---------- DIPAKAI DI BANYAK KOMPONEN ---------- */
    umum: {
      tabBaru: "terbuka di tab baru",
      selengkapnya: "Selengkapnya",
    },

    /* ---------- Footer.jsx ---------- */
    footer: {
      /* ALAMAT: NAMA JALAN DAN NOMOR TIDAK PERNAH DITERJEMAHKAN.

         Alasannya praktis, bukan soal gaya. Pengunjung asing memakai
         baris ini untuk ditunjukkan ke sopir taksi, diketik ke aplikasi
         ojek, atau ditulis di formulir pengiriman. "Buncit Raya Street"
         tidak dikenali siapa pun di Jakarta.

         Yang diterjemahkan hanya KETERANGAN WILAYAH - kata jabatan
         administratif yang memang punya padanan: Kec. (district), Kota
         (city), Daerah Khusus Ibukota (Special Capital Region). */
      alamat:
        "Jl. Warung Buncit Raya No.15, RT.10/RW.5, Kalibata, Kec. Pancoran, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12740",
      alamatPendek: "Jl. Warung Buncit Raya No.15, Jakarta Selatan",
      judulSosial: "Sosial Media Kami",
      judulKontak: "Hubungi Kami",
      judulLayanan: "Layanan 24/7",
      survey: "Isi Survey Kepuasan",
      surveyAria: "Isi survei kepuasan RS JMC, terbuka di tab baru",
      surveyBelum: "URL survei belum diisi",
      sosialAria: "{nama} RS JMC, terbuka di tab baru",
      sosialBelumAda: "{nama} belum tersedia",
      sosialBelumIsi: "URL {nama} belum diisi",
      petaAria: "Buka alamat RS JMC di Google Maps, terbuka di tab baru",
      teleponAria: "Telepon {nomor}",
      emailAria: "Kirim email ke {email}",
      situsAria: "Buka rsjmc.id, terbuka di tab baru",
      copyright: "Copyright © {tahun} IT RS JMC. All Rights Reserved.",
      waAria: "Chat WhatsApp {peran} di nomor {nomor}, terbuka di tab baru",
      telAria: "Telepon {peran} di nomor {nomor}",
      cs: "Customer Service",
      csSapaan: "Halo, Admin RS JMC. Saya ingin bertanya mengenai layanan rumah sakit. Terima kasih.",
      asuransi: "Asuransi / Umum",
      asuransiSapaan: "Halo, Admin RS JMC. Saya ingin bertanya mengenai pendaftaran pasien asuransi atau umum. Terima kasih.",
      bpjs: "BPJS",
      bpjsSapaan: "Halo, Admin RS JMC. Saya ingin bertanya mengenai pelayanan pasien BPJS. Terima kasih.",
      komplain: "Komplain",
      komplainSapaan: "Halo, Admin RS JMC. Saya ingin menyampaikan keluhan mengenai pelayanan. Terima kasih.",
    },

    /* ---------- ContactBanner.jsx ---------- */
    banner: {
      eyebrow: "Hubungi Kami",
      judul: "Kami selalu ada untuk Anda",
      waAria: "Chat WhatsApp {peran} di nomor {nomor}, terbuka di tab baru",
      telAria: "Telepon {peran} di nomor {nomor}",
      utama: "Telepon Utama",
      utamaNote: "Informasi umum dan sambungan ke seluruh unit",
      cs: "Customer Service",
      csNote: "Pertanyaan layanan, jadwal, dan janji temu",
      csSapaan: "Halo, Admin RS JMC. Saya ingin bertanya mengenai jadwal dokter dan janji temu. Terima kasih.",
      komplain: "Komplain Layanan",
      komplainNote: "Sampaikan keluhan atas pelayanan yang Anda terima",
      komplainSapaan: "Halo, Admin RS JMC. Saya ingin menyampaikan keluhan mengenai pelayanan. Terima kasih.",
    },

    /* ---------- ServiceAccordion.jsx + app/layanan ----------

       HANYA DESKRIPSI. Nama layanannya ada di header.layanan.* di atas,
       dan ketiga komponen yang memakainya membacanya dari sana. Jangan
       menambahkan kunci nama di blok ini - dua nama untuk satu layanan
       adalah cara tercepat menu dan beranda kembali menyimpang.

       Kuncinya harus cocok dengan `key` di app/data/layanan.js. Layanan
       yang tidak punya kunci Desc akan menampilkan nama kuncinya
       mentah-mentah di layar.

       dokterUmum, dokterSpesialis, dan dokterGigi DIHAPUS karena
       ketiganya tidak ada di app/data/layanan.js maupun di menu Header.
       Kalau ketiga poliklinik itu memang dilayani RS - dan halaman
       Jadwal Dokter menunjukkan iya - yang benar adalah menambahkannya
       ke app/data/layanan.js, bukan membiarkannya hilang dari situs.

       deliveryObatDesc diambil dari poster di
       /images/layanan/delivery.jpg. Tarif di poster itu (10rb untuk
       5-10 km, 20rb di atas 10 km) sengaja TIDAK dimasukkan: deskripsi
       di akordeon hanya sebaris, dan tarif berubah lebih sering
       daripada teks lain. Tarif basi di situs RS berakhir jadi
       perselisihan di kasir.

       Sepuluh deskripsi lainnya adalah DRAF, ditulis definisional tanpa
       jam, tarif, nama dokter, nama perusahaan asuransi, atau klaim
       keunggulan. Wajib ditinjau tim RS sebelum tayang - terutama
       telemedicineDesc (apakah layanannya sudah berjalan?) dan
       asuransiDesc (jangan menyiratkan penjaminan yang tidak berlaku). */
    layananList: {
      darurat: "Darurat",

      mcuDesc: "Rangkaian pemeriksaan kesehatan berkala untuk deteksi dini.",
      igdDesc: "Penanganan kondisi gawat darurat, tersedia sepanjang hari.",
      laboratoriumDesc: "Pemeriksaan sampel darah, urine, dan penunjang diagnostik lainnya.",
      apotekDesc: "Penebusan resep dan penyediaan obat langsung di lokasi.",
      deliveryObatDesc: "Pengantaran obat dari Apotek RS JMC ke alamat Anda, gratis untuk jarak hingga 5 km.",
      swabPcrDesc: "Layanan pemeriksaan swab antigen dan PCR di tempat.",
      babySpaDesc: "Kelas berenang dan pijat bayi untuk stimulasi tumbuh kembang.",
      telemedicineDesc: "Konsultasi dengan dokter secara daring, tanpa datang ke rumah sakit.",
      rawatInapDesc: "Perawatan menginap di bawah pengawasan dokter dan perawat.",
      klinikNyeriDesc: "Penanganan keluhan nyeri akut maupun menahun.",
      terapiWasirDesc: "Pemeriksaan dan penanganan wasir atau hemoroid.",
      endoskopiUrologiDesc: "Pemeriksaan saluran kemih menggunakan alat endoskopi.",
      skincareDesc: "Perawatan kulit dan estetika medis oleh tenaga kesehatan.",
      asuransiDesc: "Informasi penjaminan dan asuransi yang berlaku di RS JMC.",
      pelayananDesc: "Informasi alur pendaftaran, hak pasien, dan penyampaian keluhan.",
    },

    /* ---------- DoctorSearch.jsx ---------- */
    cari: {
      tab: "Cari Dokter",
      nama: "Nama Dokter",
      namaPlaceholder: "Ketik nama dokter",
      spesialisasi: "Spesialisasi",
      spesialisasiPlaceholder: "Semua spesialisasi",
      hari: "Hari Praktik",
      hariPlaceholder: "Semua hari",
      reset: "Reset",
      submit: "Cari Dokter",
      sp: {
        penyakitDalam: "Penyakit Dalam",
        anak: "Anak",
        kandungan: "Kebidanan & Kandungan",
        bedah: "Bedah",
        jantung: "Jantung & Pembuluh Darah",
        saraf: "Saraf",
        mata: "Mata",
        tht: "THT-KL",
        kulit: "Kulit & Kelamin",
        gigi: "Gigi & Mulut",
        umum: "Dokter Umum",
        paru: "Paru",
        urologi: "Urologi",
      },
      hariNama: {
        senin: "Senin",
        selasa: "Selasa",
        rabu: "Rabu",
        kamis: "Kamis",
        jumat: "Jumat",
        sabtu: "Sabtu",
        minggu: "Minggu",
      },
    },


    /* ---------- GoogleRating.jsx ---------- */
    rating: {
      eyebrow: "Penilaian di Google",
      bintangAria: "{nilai} dari 5 bintang",
      dari: "Dari {jumlah} ulasan · diperiksa {tanggal}",
      tombol: "Baca ulasan di Google",
      diperiksa: "Agustus 2026",
    },

    /* ---------- AddressBar.jsx ---------- */
    alamatBar: {
      thn: "Thn",
      jam: "Jam",
      unit: "Unit",
      pengalamanShort: "Pengalaman",
      pengalaman: "Pengalaman tim medis",
      layananShort: "Layanan",
      layanan: "Layanan utama tersedia",
      igdShort: "IGD",
      igd: "Instalasi gawat darurat",
      akreditasiShort: "Akreditasi",
      akreditasi: "Terakreditasi {tingkat}",
      fasilitasShort: "Fasilitas",
      fasilitas: "Fasilitas penunjang utama",
      bukaMaps: "Buka di Maps",
    },

    /* ---------- ClinicSlider.jsx ---------- */
    klinik: {
      tier: "Faskes Tingkat I",
      deskripsi:
        "Jl. Buncit Raya No. 200, Jakarta Selatan. Seberang Polsek Pancoran. Melayani pasien umum, asuransi, dan BPJS Kesehatan.",
      imageAlt: "Poster informasi Klinik Kirana",
      kodeFaskes: "Kode faskes",
      telepon: "Telepon",
      hubungi: "Hubungi klinik",
      fotoKosong: "Foto belum tersedia",
    },

    /* ---------- HeroSlider.jsx ---------- */
    hero: {
      wilayahAria: "Informasi dan promo RS JMC",
      sebelumnya: "Slide sebelumnya",
      berikutnya: "Slide berikutnya",
      keSlide: "Ke slide {nomor}",
      alt1:
        "Klinik Kirana, Jl. Buncit Raya No. 200 Jakarta Selatan. Kode faskes 0112B160. Telepon 0821 2397 2332.",
      alt2: "Ganti dengan isi teks pada poster kedua.",
      alt3: "Ganti dengan isi teks pada poster ketiga.",
    },

    /* ---------- GalleryGrid.jsx ---------- */
    galeri: {
      perbesar: "Perbesar: {teks}",
      tutup: "Tutup",
      fotoSebelumnya: "Foto sebelumnya",
      fotoBerikutnya: "Foto berikutnya",
      fotoKe: "Foto {nomor} dari {total}",
      altBawaan:
        "Suasana dan fasilitas RS Jakarta Medical Center, foto {nomor} dari {total}",
      judul: "Gallery",
      sub: "Suasana, fasilitas, dan lingkungan RS Jakarta Medical Center. Klik salah satu foto untuk melihatnya lebih besar.",
    },

    /* ---------- CenterOfExcellence.jsx ---------- */
    coe: {
      eyebrow: "Fasilitas Penunjang",
      judul: "Pusat Unggulan RS Jakarta Medical Center",
      subjudul: "Telusuri lebih lanjut berbagai fasilitas penunjang layanan kami.",
      lihatSemua: "Lihat semua fasilitas",
      ajak: "Buat Janji Temu",
      baca: "Baca Selengkapnya",
      fotoKosong: "Foto belum diisi",
      trackAria: "Fasilitas penunjang, geser untuk melihat lainnya",
      sebelumnya: "Fasilitas sebelumnya",
      berikutnya: "Fasilitas berikutnya",
      f: {
        ambulan: "Ambulan 24 Jam",
        ambulanDesc: "Layanan ambulans yang tersedia sepanjang hari untuk penjemputan dan rujukan pasien.",
        laboratorium: "Laboratorium",
        laboratoriumDesc: "Pemeriksaan laboratorium sebagai penunjang diagnosis, tersedia di lokasi.",
        apotek: "Apotek",
        apotekDesc: "Penebusan resep dan penyediaan obat langsung di dalam area rumah sakit.",
        rawatInap: "Rawat Inap",
        rawatInapDesc: "Kamar perawatan dengan beberapa pilihan kelas untuk pasien yang memerlukan observasi.",
        igd: "IGD",
        igdDesc: "Instalasi gawat darurat untuk penanganan kondisi darurat, buka 24 jam.",
        mcu: "Medical Check Up",
        mcuDesc: "Rangkaian pemeriksaan kesehatan berkala, tersedia untuk perorangan maupun perusahaan.",
        rehabilitasi: "Rehabilitasi",
        rehabilitasiDesc: "Layanan rehabilitasi medik untuk pemulihan fungsi gerak setelah cedera atau tindakan.",
        radiologi: "Radiologi",
        radiologiDesc: "Pemeriksaan pencitraan sebagai penunjang diagnosis dokter.",
        delivery: "Delivery Obat",
        deliveryDesc: "Pengantaran obat dari apotek rumah sakit ke alamat pasien.",
        atm: "ATM",
        atmDesc: "Mesin ATM di area rumah sakit untuk kebutuhan transaksi pengunjung.",
        mushola: "Mushola",
        musholaDesc: "Ruang ibadah bagi pasien, keluarga, dan pengunjung.",
        wifi: "Free Wifi",
        wifiDesc: "Akses internet nirkabel gratis di area tunggu dan ruang perawatan.",
        kafe: "Kafe / Kantin",
        kafeDesc: "Tempat makan bagi keluarga pasien dan pengunjung di dalam area rumah sakit.",
        taman: "Taman Bermain Anak",
        tamanDesc: "Area bermain untuk anak, agar waktu menunggu terasa lebih ringan bagi keluarga.",
      },
    },

    /* ---------- ArticleCarousel.jsx (hanya rangka, bukan isi artikel) ---------- */
    artikel: {
      trackAria: "Daftar artikel, geser untuk melihat lainnya",
      sebelumnya: "Artikel sebelumnya",
      berikutnya: "Artikel berikutnya",
      bagikan: "Bagikan: {judul}",
      baca: "Baca Selengkapnya",      tersalin: "Tautan tersalin",
    },

    /* ---------- TestimonialCarousel.jsx (hanya rangka) ---------- */
    testimoni: {
      judul: "Kisah Inspiratif dari Para Pasien kami",
      /* ⚠️ ENAM KUTIPAN DI BAWAH MASIH CONTOH, bukan kata-kata pasien
         sungguhan - itulah sebabnya ia aman diterjemahkan sekarang.

         BEGITU DIGANTI KISAH ASLI, ATURANNYA BERUBAH. Kutipan langsung
         adalah kata-kata yang benar-benar diucapkan seseorang. Kalau
         pasiennya berbicara Bahasa Indonesia lalu situs menampilkan
         kalimat Inggris di dalam tanda kutip atas namanya, itu kalimat
         yang tidak pernah ia ucapkan.

         Cara yang jujur: tetap terjemahkan, TAPI beri keterangan
         "Diterjemahkan dari Bahasa Indonesia" di bawah kutipan versi
         Inggris - praktik baku di media. Dan izin tertulis pasien
         sebaiknya mencakup versi terjemahannya juga, bukan hanya versi
         aslinya. */
      k1: "Saya datang ke IGD tengah malam dan langsung ditangani. Perawatnya menjelaskan setiap langkah, jadi keluarga saya tidak panik menunggu.",
      p1: "Pasien IGD",
      k2: "Proses medical check up-nya tertata, antreannya jelas, dan hasilnya bisa saya ambil di hari yang sama tanpa perlu bolak-balik.",
      p2: "Pasien Medical Check Up",
      k3: "Ruang Rawat Inap Bersih, membuat Pasien terasa Nyaman.",
      p3: "Pasien Rawat Inap",
      k4: "Anak saya biasanya takut ke dokter gigi. Di sini dia mau duduk sendiri sampai selesai, dan pulang-pulang malah minta kontrol lagi bulan depan.",
      p4: "Pasien Dokter Gigi",
      k5: "Kelas baby spa-nya membantu sekali untuk ibu baru seperti saya. Petugasnya sabar mengajari, tidak buru-buru.",
      p5: "Pasien Baby Spa",
      k6: "Kontrol rutin saya jadi lebih ringan karena jadwalnya bisa diatur dan apoteknya ada di gedung yang sama.",
      p6: "Pasien Rawat Jalan",
      trackAria: "Kisah pasien, geser untuk melihat lainnya",
      sebelumnya: "Kisah sebelumnya",
      berikutnya: "Kisah berikutnya",
    },

    /* ---------- page.jsx (beranda) ---------- */
    beranda: {
      klinikEyebrow: "Faskes Tingkat I",
      klinikJudul: "Klinik Kirana",

      klinikSub:
        "Faskes tingkat pertama RS Jakarta Medical Center untuk pemeriksaan, pengobatan, dan pemeriksaan penunjang. Melayani pasien umum, asuransi, dan BPJS Kesehatan.",

      layananEyebrow: "Layanan Kami",
      layananJudul: "Fasilitas & Layanan",
      layananSub:
        "Layanan rawat jalan, penunjang medis, dan gawat darurat dalam satu tempat. Pilih layanan untuk melihat detailnya.",
      layananCta: "Lihat semua layanan",

      kenapaEyebrow: "Kenapa Kami",
      kenapaJudul: "Kenapa memilih RS Jakarta Medical Center",
      kenapaSub: "Empat hal yang jadi dasar cara kami melayani pasien.",

      fasilitasEyebrow: "Fasilitas",
      fasilitasJudul1: "Terus Berkembang dan Bersaing",
      fasilitasJudul2: "Dalam Menyediakan Teknologi Terkemuka",

      artikelEyebrow: "Edukasi Kesehatan",
      artikelJudul: "Berita & Artikel Kesehatan",
      artikelSub: "Informasi dan tips kesehatan yang ditinjau oleh dokter kami.",
      artikelCta: "Lihat semua berita & artikel kesehatan",

      alasan: {
        kualitas: "Kualitas",
        kualitasTeks: "Kami senantiasa memberikan kualitas pelayanan terbaik dengan service excellence",
        kenyamanan: "Kenyamanan",
        kenyamananTeks: "Nyaman seperti di rumah lengkap dengan taman bermain anak & coffee/kantin sehat",
        keamanan: "Keamanan",
        keamananTeks: "Privasi Anda 100% Terjaga Oleh kami",
        pakar: "Pakar Ahli",
        pakarTeks: "Tim Ahli dari berbagai disiplin ilmu hingga pengalaman >30th",
      },

      /* Keempat nama alat ini sengaja TIDAK diterjemahkan - istilahnya
         sudah bahasa Inggris dan dipakai apa adanya di rumah sakit
         Indonesia. Tetap diberi kunci supaya kalau suatu saat berubah,
         tempatnya sudah ada. */
      fas: {
        ot: "Operating Theatre",
        ct: "CT-Scan",
        nicu: "NICU-PICU",
        icu: "ICU-ICCU",
      },
    },
    /* ---------- app/tentang-kami/about ---------- */
    about: {
      breadcrumb: "Breadcrumb",
      eyebrow: "Tentang Kami",
      judul: "Rumah Sakit Jakarta Medical Center",
      singkatan: "RS JMC",
      p1: "Rumah Sakit Jakarta Medical Center didirikan pada 15 November 1993 sebagai rumah sakit umum swasta, dan telah terakreditasi oleh Komisi Akreditasi Rumah Sakit (KARS).",
      p2: "Layanan kami mencakup rawat jalan, rawat inap, gawat darurat 24 jam, laboratorium, dan pemeriksaan penunjang, dengan keunggulan pada spesialisasi Penyakit Dalam beserta berbagai konsultasi ahli di dalamnya.",
      fotoKeterangan: "Gedung RS Jakarta Medical Center, Jl. Warung Buncit Raya, Jakarta Selatan.",
      ctaKontak: "Hubungi Kami",
      ctaJadwal: "Lihat Jadwal Dokter",
      lokasi: "Lokasi",
      kota: "Jakarta Selatan",
      bukaMaps: "Buka di Google Maps",
      fotoKosong: "Foto gedung belum diisi",
      fotoPetunjuk: "Simpan fotonya di public/images/, lalu isi konstanta FOTO_GEDUNG di berkas ini.",
      fotoAlt: "Gedung RS Jakarta Medical Center, Jl. Warung Buncit Raya, Jakarta Selatan.",
      fakta: {
        berdiri: "Berdiri sejak",
        berdiriCatatan: "15 November 1993",
        status: "Status",
        statusNilai: "Swasta",
        statusCatatan: "Rumah sakit umum swasta",
        akreditasi: "Akreditasi",
        akreditasiCatatan: "Komisi Akreditasi Rumah Sakit",
        faskes: "Faskes Tingkat I",
        faskesCatatan: "Kode 0112B160",
      },
    },

    /* ---------- VisiMisi.jsx ----------

       ⚠️⚠️ DOKUMEN RESMI. VERSI INDONESIA ADALAH YANG BERLAKU.

       Visi, misi, dan motto dipakai saat penilaian KARS, dan versi di
       situs harus sama persis dengan versi yang diserahkan ke sana.
       Teks Indonesia di bawah disalin apa adanya - JANGAN diubah tanpa
       persetujuan manajemen.

       TERMASUK "pada tahun 2024" YANG SUDAH LEWAT. Sekarang 2026, dan
       target itu terlewat dua tahun. Saya TIDAK membetulkannya, karena
       menghapus tahunnya membuat isi situs berbeda dengan dokumen
       resmi. Tanyakan ke manajemen apakah visinya sudah diperbarui.

       VERSI INGGRIS DI BAWAH ADALAH TERJEMAHAN KERJA, BUKAN DOKUMEN.
       Ia perlu ditinjau dan disetujui manajemen sebelum tayang, sama
       seperti versi Indonesianya. Kalau RS belum siap mengeluarkan
       versi Inggris resmi, pilihan yang lebih aman adalah menyalin
       teks Indonesia ke kolom `en` juga - visi berbahasa Indonesia di
       halaman Inggris masih lebih jujur daripada versi Inggris yang
       belum disetujui.

       Satu ketidakcocokan yang perlu diselesaikan lepas dari
       terjemahan: visi menyebut keunggulan pada "hipertensi dan
       hemodialisa", sementara paragraf di halaman About menyebut
       "spesialisasi Penyakit Dalam". Dua berkas, dua klaim berbeda. */
    visimisi: {
      judul: "Visi, Misi, dan Motto",
      visi: "Visi",
      visiIsi: "Menjadi rumah sakit swasta pilihan masyarakat dan pusat rujukan pasien hipertensi dan hemodialisa di Jakarta dan sekitarnya pada tahun 2024.",
      misi: "Misi",
      misi1: "Meningkatkan mutu pelayanan dengan SDM yang mampu bersaing dan mempunyai kompetensi sesuai tugas dan wewenang",
      misi2: "Meningkatkan fasilitas yang berkualitas dengan harga terjangkau sesuai jaminan yang ada",
      misi3: "Meningkatkan ketersediaan obat-obatan dan menyiapkan alat-alat yang dibutuhkan untuk memberikan pelayanan terbaik",
      misi4: "Meningkatkan ketersediaan alat dengan kemampuan teknologi dan sesuai standar yang ada di Indonesia",
      misi5: "Meningkatkan sistem yang efisien, efektif, transparan dan akuntabel",
      motto: "Motto",
      mottoIsi: "Kepuasan Anda Dambaan Kami dan Pelayanan Kesehatan Terbaik Bukan Termahal",
    },

    /* ---------- app/edukasi-kesehatan ---------- */
    edukasi: {
      eyebrow: "Edukasi Kesehatan",
      judul: "Materi Edukasi Pasien",
      sub: "Leaflet, flyer, dan poster yang dibagikan di RS JMC. Pilih satu untuk membacanya lebih besar.",
      tabAria: "Jenis materi",
      leaflet: "Leaflet",
      flyer: "Flyer",
      poster: "Poster",
      jumlah: "{n} materi",
      halaman: "{n} halaman",
      satuHalaman: "1 halaman",
      buka: "Buka materi {judul}",
      kosong: "Belum ada materi di kategori ini.",
      kosongPetunjuk: "Tambahkan datanya di app/edukasi-kesehatan/data.js.",
      gambarKosong: "Gambar belum diisi",
      tutup: "Tutup",
      kembali: "Kembali ke daftar",
      perbesar: "Perbesar gambar",
      perkecil: "Kecilkan gambar",
      aturUlang: "Kembalikan ke ukuran semula",
      tingkatZoom: "Tingkat perbesaran {persen} persen",
      geserPetunjuk: "Tekan dan geser untuk melihat sisi lain gambar",
      sebelumnya: "Halaman sebelumnya",
      berikutnya: "Halaman berikutnya",
      posisi: "Halaman {nomor} dari {total}",
      altBawaan: "{judul}, halaman {nomor} dari {total}",
      catatan:
        "Materi ini bersifat informasi umum dan tidak menggantikan pemeriksaan dokter. Untuk keluhan yang Anda alami, silakan berkonsultasi langsung dengan tenaga medis.",
    },

    /* ---------- Halaman artikel: /edukasi-kesehatan/<slug> ---------- */
    artikelDetail: {
      breadcrumb: "Berita & Artikel Kesehatan",
      label: "Artikel",
      oleh: "Oleh {penulis}",
      bagikan: "Bagikan artikel ini",
      bagikanKe: "Bagikan ke {jaringan}",
      salinTautan: "Salin tautan",
      tautanTersalin: "Tautan tersalin",
      bacaJuga: "Baca juga:",
      faq: "Pertanyaan yang Sering Diajukan",
      referensi: "Referensi",
      diakses: "Diakses pada {tanggal}",
      terkait: "Artikel Terkait",
      sumberMateri: "Materi cetak terkait",
      sumberMateriTeks: "Artikel ini disusun dari materi edukasi yang dibagikan di RS JMC. Lihat versi cetaknya:",
      kembali: "Kembali ke Edukasi Kesehatan",
      ditinjau: "Ditinjau oleh {peninjau}",
      catatan:
        "Artikel ini bersifat informasi umum dan tidak menggantikan pemeriksaan dokter. Untuk keluhan yang Anda alami, silakan berkonsultasi langsung dengan tenaga medis.",
    },

    /* ---------- Daftar artikel: /edukasi-kesehatan/artikel ---------- */
    daftarArtikel: {
      eyebrow: "Edukasi Kesehatan",
      judul: "Berita & Artikel Kesehatan",
      sub: "Informasi dan tips kesehatan yang disusun dari materi edukasi RS JMC.",
      cari: "Cari artikel",
      cariPlaceholder: "Ketik kata kunci",
      hasil: "{n} artikel ditemukan",
      kosong: "Tidak ada artikel yang cocok dengan pencarian Anda.",
      kosongPetunjuk: "Coba kata kunci lain, atau kosongkan kolom pencarian.",
      belumAda: "Belum ada artikel.",
      belumAdaPetunjuk: "Tambahkan datanya di app/edukasi-kesehatan/artikel.js.",
      baca: "Baca Selengkapnya",
      bersihkan: "Bersihkan pencarian",
      terbaru: "Artikel terbaru",
    },

    lang: {
      id: "Bahasa Indonesia",
      en: "English",
    },
  },

  en: {
    header: {
      utility: {
        contact: "Contact Us",
        welcome: "Welcome to JMC Hospital",
        welcomeShort: "Welcome",
        brand: "JMC Hospital",
      },
      cta: {
        contact: "Contact",
        appointment: "Book an Appointment",
      },
      nav: {
        home: "Home",
        schedule: "Doctor Schedule",
        career: "JMC Careers",
      },
      menu: {
        layanan: {
          label: "Facilities & Services",
          cta: "View all services",
          promo: {
            title: "Supporting facilities",
            p1: "Operating Theatre",
            p2: "CT-Scan",
            p3: "NICU-PICU",
            p4: "ICU-ICCU",
          },
        },
        tentang: {
          label: "About Us",
          cta: "More about us",
          promo: {
            title: "As comfortable as home",
            p1: "Children's playground",
            p2: "Healthy canteen",
            p3: "Family waiting area",
          },
        },
      },
      layanan: {
        dokterUmum: "General Practitioner",
        dokterSpesialis: "Specialist Doctors",
        dokterGigi: "Dental Care",
        mcu: "Medical Check Up",
        igd: "Emergency Department (ER)",
        laboratorium: "Complete Laboratory",
        apotek: "Pharmacy",
        deliveryObat: "Medicine Delivery",
        swabPcr: "Swab & PCR Test",
        babySpa: "Baby Spa",
        telemedicine: "Telemedicine",
        rawatInap: "Inpatient Care",
        klinikNyeri: "Pain Clinic",
        terapiWasir: "Hemorrhoid Treatment",
        endoskopiUrologi: "Urological Endoscopy",
        skincare: "JMC Skincare",
        asuransi: "Insurance",
        pelayanan: "Patient Services",
      },
      tentang: {
        about: "About",
        aboutDesc: "JMC Hospital profile and history",
        businessUnit: "Business Unit",
        businessUnitDesc: "Business units and related services",
        gallery: "Gallery",
        galleryDesc: "Photos of our activities and facilities",
        edukasi: "Health Education",
        edukasiDesc: "Articles and tips from our doctors",
      },
      a11y: {
        openMenu: "Open menu",
        closeMenu: "Close menu",
        chooseLanguage: "Choose language",
      },
    },

    umum: {
      tabBaru: "opens in a new tab",
      selengkapnya: "Read more",
    },

    footer: {
      alamat:
        "Jl. Warung Buncit Raya No.15, RT.10/RW.5, Kalibata, Pancoran District, South Jakarta, Jakarta Special Capital Region 12740",
      alamatPendek: "Jl. Warung Buncit Raya No.15, South Jakarta",
      judulSosial: "Follow Us",
      judulKontak: "Contact Us",
      judulLayanan: "24/7 Services",
      survey: "Fill in Satisfaction Survey",
      surveyAria: "Fill in the JMC Hospital satisfaction survey, opens in a new tab",
      surveyBelum: "Survey URL not set yet",
      sosialAria: "JMC Hospital on {nama}, opens in a new tab",
      sosialBelumAda: "{nama} not available yet",
      sosialBelumIsi: "{nama} URL not set yet",
      petaAria: "Open the JMC Hospital address in Google Maps, opens in a new tab",
      teleponAria: "Call {nomor}",
      emailAria: "Send an email to {email}",
      situsAria: "Open rsjmc.id, opens in a new tab",
      copyright: "Copyright © {tahun} IT RS JMC. All Rights Reserved.",
      waAria: "Chat on WhatsApp with {peran} at {nomor}, opens in a new tab",
      telAria: "Call {peran} at {nomor}",
      cs: "Customer Service",
      csSapaan: "Hello, JMC Hospital. I would like to ask about your hospital services. Thank you.",
      asuransi: "Insurance / Self-pay",
      asuransiSapaan: "Hello, JMC Hospital. I would like to ask about registration for insurance or self-paying patients. Thank you.",
      bpjs: "BPJS",
      bpjsSapaan: "Hello, JMC Hospital. I would like to ask about services for BPJS patients. Thank you.",
      komplain: "Complaints",
      komplainSapaan: "Hello, JMC Hospital. I would like to submit a complaint about your service. Thank you.",
    },

    banner: {
      eyebrow: "Contact Us",
      judul: "We are always here for you",
      waAria: "Chat on WhatsApp with {peran} at {nomor}, opens in a new tab",
      telAria: "Call {peran} at {nomor}",
      utama: "Main Phone Line",
      utamaNote: "General information and transfers to all units",
      cs: "Customer Service",
      csNote: "Service enquiries, schedules, and appointments",
      csSapaan: "Hello, JMC Hospital. I would like to ask about doctor schedules and appointments. Thank you.",
      komplain: "Service Complaints",
      komplainNote: "Tell us about the service you received",
      komplainSapaan: "Hello, JMC Hospital. I would like to submit a complaint about your service. Thank you.",
    },

    /* Lihat catatan pada blok layananList versi Indonesia di atas.
       Struktur kedua blok HARUS sama persis: kunci yang ada di id tapi
       tidak ada di en akan diam-diam menampilkan teks Indonesia. */
    layananList: {
      darurat: "Emergency",

      mcuDesc: "Routine health screening packages for early detection.",
      igdDesc: "Emergency care, available around the clock.",
      laboratoriumDesc: "Blood, urine, and other diagnostic sample testing.",
      apotekDesc: "Prescription dispensing and medicines available on site.",
      deliveryObatDesc: "Medicines delivered from the JMC pharmacy to your address, free within 5 km.",
      swabPcrDesc: "Antigen swab and PCR testing on site.",
      babySpaDesc: "Baby swimming and massage classes to support development.",
      telemedicineDesc: "Online consultation with a doctor, without visiting the hospital.",
      rawatInapDesc: "Overnight care under the supervision of doctors and nurses.",
      klinikNyeriDesc: "Treatment for acute and long-standing pain.",
      terapiWasirDesc: "Examination and treatment of haemorrhoids.",
      endoskopiUrologiDesc: "Urinary tract examination using an endoscope.",
      skincareDesc: "Skin care and medical aesthetics by health professionals.",
      asuransiDesc: "Information on insurance and coverage accepted at JMC Hospital.",
      pelayananDesc: "Information on registration, patient rights, and how to raise a complaint.",
    },

    cari: {
      tab: "Find a Doctor",
      nama: "Doctor's Name",
      namaPlaceholder: "Type a doctor's name",
      spesialisasi: "Specialty",
      spesialisasiPlaceholder: "All specialties",
      hari: "Practice Day",
      hariPlaceholder: "All days",
      reset: "Reset",
      submit: "Find a Doctor",
      sp: {
        penyakitDalam: "Internal Medicine",
        anak: "Paediatrics",
        kandungan: "Obstetrics & Gynaecology",
        bedah: "Surgery",
        jantung: "Cardiology",
        saraf: "Neurology",
        mata: "Ophthalmology",
        tht: "ENT (Head & Neck)",
        kulit: "Dermatology & Venereology",
        gigi: "Dentistry",
        umum: "General Practitioner",
        paru: "Pulmonology",
        urologi: "Urology",
      },
      hariNama: {
        senin: "Monday",
        selasa: "Tuesday",
        rabu: "Wednesday",
        kamis: "Thursday",
        jumat: "Friday",
        sabtu: "Saturday",
        minggu: "Sunday",
      },
    },


    rating: {
      eyebrow: "Google rating",
      bintangAria: "{nilai} out of 5 stars",
      dari: "From {jumlah} reviews · checked {tanggal}",
      tombol: "Read reviews on Google",
      diperiksa: "August 2026",
    },

    alamatBar: {
      thn: "Yrs",
      jam: "Hrs",
      unit: "Units",
      pengalamanShort: "Experience",
      pengalaman: "Medical team experience",
      layananShort: "Services",
      layanan: "Core services available",
      igdShort: "ER",
      igd: "Emergency department",
      akreditasiShort: "Accreditation",
      akreditasi: "{tingkat} accreditation",
      fasilitasShort: "Facilities",
      fasilitas: "Key supporting facilities",
      bukaMaps: "Open in Maps",
    },

    klinik: {
      tier: "Primary Care Facility (Faskes Tingkat I)",
      deskripsi:
        "Jl. Buncit Raya No. 200, South Jakarta. Opposite Pancoran Police Station. Serving self-paying, insured, and BPJS patients.",
      imageAlt: "Klinik Kirana information poster",
      kodeFaskes: "Facility code",
      telepon: "Phone",
      hubungi: "Call the clinic",
      fotoKosong: "Photo not available yet",
    },

    hero: {
      wilayahAria: "JMC Hospital news and promotions",
      sebelumnya: "Previous slide",
      berikutnya: "Next slide",
      keSlide: "Go to slide {nomor}",
      alt1:
        "Klinik Kirana, Jl. Buncit Raya No. 200 South Jakarta. Facility code 0112B160. Phone 0821 2397 2332.",
      alt2: "Replace with the text shown on the second poster.",
      alt3: "Replace with the text shown on the third poster.",
    },

    galeri: {
      perbesar: "Enlarge: {teks}",
      tutup: "Close",
      fotoSebelumnya: "Previous photo",
      fotoBerikutnya: "Next photo",
      fotoKe: "Photo {nomor} of {total}",
      altBawaan:
        "Facilities and surroundings at Jakarta Medical Center Hospital, photo {nomor} of {total}",
      judul: "Gallery",
      sub: "The atmosphere, facilities, and surroundings of Jakarta Medical Center Hospital. Tap any photo to view it larger.",
    },

    coe: {
      eyebrow: "Supporting Facilities",
      judul: "Centres of Excellence at Jakarta Medical Center Hospital",
      subjudul: "Explore the facilities that support our services.",
      lihatSemua: "View all facilities",
      ajak: "Book an Appointment",
      baca: "Read more",
      fotoKosong: "Photo not added yet",
      trackAria: "Supporting facilities, swipe to see more",
      sebelumnya: "Previous facility",
      berikutnya: "Next facility",
      f: {
        ambulan: "24-Hour Ambulance",
        ambulanDesc: "Ambulance service available around the clock for patient pickup and referrals.",
        laboratorium: "Laboratory",
        laboratoriumDesc: "On-site laboratory testing to support diagnosis.",
        apotek: "Pharmacy",
        apotekDesc: "Prescription dispensing and medicines available inside the hospital.",
        rawatInap: "Inpatient Care",
        rawatInapDesc: "Patient rooms in several classes for those who need observation.",
        igd: "Emergency Department",
        igdDesc: "Emergency care for urgent conditions, open 24 hours.",
        mcu: "Medical Check Up",
        mcuDesc: "Routine health screening packages for individuals and companies.",
        rehabilitasi: "Rehabilitation",
        rehabilitasiDesc: "Medical rehabilitation to restore movement after injury or a procedure.",
        radiologi: "Radiology",
        radiologiDesc: "Diagnostic imaging to support your doctor's assessment.",
        delivery: "Medicine Delivery",
        deliveryDesc: "Medicines delivered from the hospital pharmacy to the patient's address.",
        atm: "ATM",
        atmDesc: "An ATM inside the hospital for visitors' banking needs.",
        mushola: "Prayer Room",
        musholaDesc: "A prayer room for patients, families, and visitors.",
        wifi: "Free Wifi",
        wifiDesc: "Free wireless internet in waiting areas and patient rooms.",
        kafe: "Café / Canteen",
        kafeDesc: "A place to eat for patients' families and visitors inside the hospital.",
        taman: "Children's Playground",
        tamanDesc: "A play area for children, to make waiting easier for families.",
      },
    },

    artikel: {
      trackAria: "Article list, swipe to see more",
      sebelumnya: "Previous article",
      berikutnya: "Next article",
      bagikan: "Share: {judul}",
      baca: "Read more",      tersalin: "Link copied",
    },

    testimoni: {
      judul: "Stories from Our Patients",
      k1: "SAMPLE - I came to the emergency department in the middle of the night and was seen straight away. The nurse explained every step, so my family did not panic while waiting.",
      p1: "Emergency Department patient",
      k2: "SAMPLE - This quote is deliberately longer, to test whether the cards stay the same height when the text length varies. The medical check up was well organised, the queue was clear, and I could collect my results the same day without coming back.",
      p2: "Medical Check Up patient",
      k3: "SAMPLE - A short quote, to test the other extreme.",
      p3: "Inpatient",
      k4: "SAMPLE - My child is usually afraid of the dentist. Here she sat through the whole appointment on her own, and afterwards even asked to come back next month.",
      p4: "Dental patient",
      k5: "SAMPLE - The baby spa classes helped a lot for a new mother like me. The staff were patient and never rushed us.",
      p5: "Baby Spa patient",
      k6: "SAMPLE - My routine check-ups are easier now because the schedule is flexible and the pharmacy is in the same building.",
      p6: "Outpatient",
      trackAria: "Patient stories, swipe to see more",
      sebelumnya: "Previous story",
      berikutnya: "Next story",
    },

    beranda: {
      klinikEyebrow: "Primary Care Facility",
      klinikJudul: "Klinik Kirana",

      klinikSub:
        "The primary care facility of Jakarta Medical Center Hospital for examinations, treatment, and supporting tests. Serving self-paying, insured, and BPJS patients.",

      layananEyebrow: "Our Services",
      layananJudul: "Facilities & Services",
      layananSub:
        "Outpatient care, diagnostic support, and emergency services in one place. Select a service to see the details.",
      layananCta: "View all services",

      kenapaEyebrow: "Why Us",
      kenapaJudul: "Why choose Jakarta Medical Center Hospital",
      kenapaSub: "Four principles behind the way we care for patients.",

      fasilitasEyebrow: "Facilities",
      fasilitasJudul1: "Growing and Competing",
      fasilitasJudul2: "To Provide Leading Technology",

      artikelEyebrow: "Health Education",
      artikelJudul: "Health News & Articles",
      artikelSub: "Health information and tips reviewed by our doctors.",
      artikelCta: "View all health news & articles",

      alasan: {
        kualitas: "Quality",
        kualitasTeks: "We consistently deliver the best standard of care through service excellence",
        kenyamanan: "Comfort",
        kenyamananTeks: "As comfortable as home, with a children's playground and a healthy café and canteen",
        keamanan: "Privacy",
        keamananTeks: "Your privacy is fully protected with us",
        pakar: "Expert Team",
        pakarTeks: "Specialists across many disciplines, with over 30 years of experience",
      },

      fas: {
        ot: "Operating Theatre",
        ct: "CT-Scan",
        nicu: "NICU-PICU",
        icu: "ICU-ICCU",
      },
    },
    about: {
      breadcrumb: "Breadcrumb",
      eyebrow: "About Us",
      judul: "Jakarta Medical Center Hospital",
      singkatan: "JMC Hospital",
      p1: "Jakarta Medical Center Hospital was founded on 15 November 1993 as a private general hospital, and is accredited by the Indonesian Hospital Accreditation Commission (KARS).",
      p2: "Our services cover outpatient care, inpatient care, 24-hour emergency care, laboratory testing, and diagnostic support, with particular strength in Internal Medicine and the specialist consultations within it.",
      fotoKeterangan: "The Jakarta Medical Center Hospital building on Jl. Warung Buncit Raya, South Jakarta.",
      ctaKontak: "Contact Us",
      ctaJadwal: "View Doctor Schedule",
      lokasi: "Location",
      kota: "South Jakarta",
      bukaMaps: "Open in Google Maps",
      fotoKosong: "Building photo not added yet",
      fotoPetunjuk: "Save the photo in public/images/, then fill in the FOTO_GEDUNG constant in this file.",
      fotoAlt: "The Jakarta Medical Center Hospital building on Jl. Warung Buncit Raya, South Jakarta.",
      fakta: {
        berdiri: "Established",
        berdiriCatatan: "15 November 1993",
        status: "Status",
        statusNilai: "Private",
        statusCatatan: "Private general hospital",
        akreditasi: "Accreditation",
        akreditasiCatatan: "Indonesian Hospital Accreditation Commission",
        faskes: "Primary Care Facility",
        faskesCatatan: "Code 0112B160",
      },
    },

    visimisi: {
      judul: "Vision, Mission, and Motto",
      visi: "Vision",
      visiIsi: "To be the private hospital of choice for the community and a referral centre for hypertension and haemodialysis patients in Jakarta and the surrounding area by 2024.",
      misi: "Mission",
      misi1: "To improve the quality of care through staff who are competitive and competent in their duties and authority",
      misi2: "To improve the quality of facilities at affordable prices in line with available insurance coverage",
      misi3: "To improve the availability of medicines and prepare the equipment needed to deliver the best care",
      misi4: "To improve the availability of equipment with technological capability that meets Indonesian standards",
      misi5: "To improve systems that are efficient, effective, transparent, and accountable",
      motto: "Motto",
      mottoIsi: "Your satisfaction is our aspiration, and the best healthcare is not the most expensive",
    },

    edukasi: {
      eyebrow: "Health Education",
      judul: "Patient Education Materials",
      sub: "Leaflets, flyers, and posters handed out at JMC Hospital. Select one to read it larger.",
      tabAria: "Material type",
      leaflet: "Leaflet",
      flyer: "Flyer",
      poster: "Poster",
      jumlah: "{n} items",
      halaman: "{n} pages",
      satuHalaman: "1 page",
      buka: "Open {judul}",
      kosong: "No materials in this category yet.",
      kosongPetunjuk: "Add them in app/edukasi-kesehatan/data.js.",
      gambarKosong: "Image not added yet",
      tutup: "Close",
      kembali: "Back to list",
      perbesar: "Zoom in",
      perkecil: "Zoom out",
      aturUlang: "Reset to original size",
      tingkatZoom: "Zoom level {persen} percent",
      geserPetunjuk: "Click and drag to see other parts of the image",
      sebelumnya: "Previous page",
      berikutnya: "Next page",
      posisi: "Page {nomor} of {total}",
      altBawaan: "{judul}, page {nomor} of {total}",
      catatan:
        "These materials are general information and do not replace a medical examination. For symptoms you are experiencing, please consult a healthcare professional directly.",
    },

    artikelDetail: {
      breadcrumb: "Health News & Articles",
      label: "Article",
      oleh: "By {penulis}",
      bagikan: "Share this article",
      bagikanKe: "Share on {jaringan}",
      salinTautan: "Copy link",
      tautanTersalin: "Link copied",
      bacaJuga: "See also:",
      faq: "Frequently Asked Questions",
      referensi: "References",
      diakses: "Accessed on {tanggal}",
      terkait: "Related Articles",
      sumberMateri: "Related printed material",
      sumberMateriTeks: "This article is based on education materials handed out at JMC Hospital. See the printed version:",
      kembali: "Back to Health Education",
      ditinjau: "Reviewed by {peninjau}",
      belumDitinjau: "Not yet reviewed by a doctor - do not publish.",
      catatan:
        "This article is general information and does not replace a medical examination. For symptoms you are experiencing, please consult a healthcare professional directly.",
    },

    daftarArtikel: {
      eyebrow: "Health Education",
      judul: "Health News & Articles",
      sub: "Health information and tips drawn from JMC Hospital education materials.",
      cari: "Search articles",
      cariPlaceholder: "Type a keyword",
      hasil: "{n} articles found",
      kosong: "No articles match your search.",
      kosongPetunjuk: "Try a different keyword, or clear the search box.",
      belumAda: "No articles yet.",
      belumAdaPetunjuk: "Add them in app/edukasi-kesehatan/artikel.js.",
      baca: "Read more",
      bersihkan: "Clear search",
      terbaru: "Latest article",
    },

    lang: {
      id: "Bahasa Indonesia",
      en: "English",
    },
  },
};

/* Daftar bahasa yang tersedia. LanguageProvider memakainya untuk
   memvalidasi nilai yang dibaca dari localStorage - kalau seseorang
   mengubahnya lewat DevTools jadi "fr", nilainya ditolak dan kembali
   ke default alih-alih membuat seluruh situs kehilangan teks. */
export const LOCALES = ["id", "en"];
export const DEFAULT_LOCALE = "id";
